import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable, of as observableOf } from 'rxjs';

import { ICoreConfigInternal } from '@core/core.config.model';

import { IEnterprise } from './enterprise.model';

@Injectable()
export class EnterpriseService {
    private apiUrl: string;
    private enterpriseInfo: IEnterprise;

    constructor(private http: HttpClient, @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal) {
        this.apiUrl = `${ config.apiEndpoint }api/public`;
    }

    public getEnterpriseInfo(): Observable<IEnterprise> {
        if (this.enterpriseInfo) { return observableOf(this.enterpriseInfo); }

        return this.http.get<IEnterprise>(`${ this.apiUrl }/enterprise-info/`);
    }
}
